import Button from "../button/button";
import AddIcon from "@mui/icons-material/Add";
import "./view-modal.scss";
import { useState } from "react";
import Modal from "../modal/modal";
import {
  DialogActions,
  DialogTitle,
  IconButton,
  MenuItem,
  Tab,
  Tabs
} from "@mui/material";
import { useTheme, useMediaQuery } from "@mui/material";
import Typography from "../typography/typography";
import CloseIcon from "@mui/icons-material/Close";
import logo from "../../assets/images";
import Select from "../select/select";
import viewTypes from "../../constants/action-bar";

interface ActionData {
  label: string;
  position: number;
}
interface ModalPropsType {
  setData: React.Dispatch<React.SetStateAction<ActionData[]>>;
  data: Array<object>;
  setActive: React.Dispatch<React.SetStateAction<string>>;
  disabledViews?: string[]
}

const ViewModal = (props: ModalPropsType) => {
  const { data, setData, setActive, disabledViews = [] } = props;
  const [openModal, setOpenModal] = useState(false);
  const [value, setValue] = useState("Table");
  const [disable, setDisable] = useState(false);
  const theme = useTheme();
  const isMdUp = useMediaQuery(theme.breakpoints.up('lg'));
  const handleTabChange = (_: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
    setDisable(
      Boolean(
        data.find(
          (item: any) => item.label.toLowerCase() === newValue.toLowerCase(),
        ),
      ),
    );
  };

  const TabData = [
    {
      label: "Table",
      icon: <logo.TableIcon />,
      desc: "Easily manage, update, and organize your tasks with Table view.",
      image: <img src={logo.table} />,
    },
    {
      label: "Grid",
      icon: <logo.GridIcon />,
      desc: "Grid of cards, use for mood boards, index cards, and recipes",
      image: <img src={logo.grid} />,
    },
    // {
    //   label: "Kanban",
    //   icon: <logo.KanbanIcon />,
    //   desc: "Build your perfect Board and easily drag-and-drop tasks between columns.",
    //   image: <img src={logo.kanban} />,
    // },
    // {
    //   label: "Calendar",
    //   icon: <logo.CalenderIcon />,
    //   desc: "Calendar view is your place for planning, scheduling, and resource management.",
    //   image: <img src={logo.calendar} />,
    // },
    // {
    //   label: "Gantt",
    //   icon: <logo.GanttIcon />,
    //   desc: "Plan time, manage resources, visualize dependencies and more with Gantt view.",
    //   image: <img src={logo.gantt} />,
    // },
  ];

  const handleSubmit = () => {
    const selectedTabData = TabData.find(
      (data) => data.label.toLowerCase() === value.toLowerCase(),
    );
    if (selectedTabData?.label) {
      if (
        !data.some(
          (item: any) => item.label.toLowerCase() === value.toLowerCase(),
        )
      ) {
        setData([
          ...(data as ActionData[]),
          { label: selectedTabData.label, position: data.length },
        ]);

        setActive(selectedTabData?.label);
        setOpenModal(false);
      }
    }
  };

  return (
    <div className="view-modal">
      <div className="view-modal--Header">
        |
        <Button
          variant="text"
          startIcon={<AddIcon />}
          sx={isMdUp ? {} : { pr:0 }}
          onClick={() => {
            setOpenModal(true);
            setDisable(
              Boolean(
                data.find(
                  (item: any) =>
                    item.label.toLowerCase() === value.toLowerCase(),
                ),
              ),
            );
          }}
        >
          {isMdUp ? 'View' : ''}
        </Button>
      </div>
      <Modal
        open={openModal}
        onClose={() => setOpenModal(false)}
        className="view-modal"
      >
        <DialogTitle className="view-modal--Head">
          <Typography type="s3" weight="medium" color="#000">
            Add View
          </Typography>
          <IconButton onClick={() => setOpenModal(false)}>
            <CloseIcon fontSize="small"/>
          </IconButton>
        </DialogTitle>

        <div className="view-modal--TabsContent">
          <Tabs
            orientation="vertical"
            value={value}
            onChange={handleTabChange}
            className="view-modal--Tab"
          >
            {TabData &&
              TabData?.map((data) => (
                <Tab
                  key={data.label}
                  label={`${data?.label} View`}
                  iconPosition="start"
                  icon={data?.icon}
                  value={data.label}
                  className="view-modal--Tabs"
                  disabled={Boolean(disabledViews?.includes(data.label))}
                />
              ))}
          </Tabs>
          {TabData.map((data) => (
            <div
              key={data.label}
              hidden={value !== data.label}
              className="view-modal--TabData"
            >
              {data.image}
              <div className="view-modal--Desc">
                <Typography type="s1" color={"theme.secondary.1000"}>
                  {data?.label} Views
                </Typography>
                <Typography type="s4" color={"theme.secondary.800"}>
                  {data.desc}
                </Typography>
                {(data?.label === viewTypes.KANBAN ||
                  data?.label === viewTypes.CALENDAR) && (
                  <div className="view-modal--BoardContainer">
                    <Typography type="s4" color="theme.secondary.900">
                      Group Board by
                    </Typography>
                    <Select
                      placeholder="Status"
                      size={"small"}
                      defaultValue={1}
                      className="view-modal--Select"
                      variant="outlined"
                    >
                      <MenuItem value={1}>option 1</MenuItem>
                      <MenuItem value={2}>option 2</MenuItem>
                    </Select>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
        <DialogActions
          className="view-modal--Actions"
          sx={{ backgroundColor: "theme.secondary.200" }}
        >
          <Button variant="text" onClick={() => setOpenModal(false)}>
            Cancel
          </Button>
          <Button variant="contained" onClick={handleSubmit} disabled={disable}>
            Add {value} View
          </Button>
        </DialogActions>
      </Modal>
    </div>
  );
};

export { ViewModal };
export default ViewModal;
